import {
  CUSTOM_NOTE_CONTEXT,
  CustomNoteLabel,
  IProductType,
  IProductTypeOverview,
} from '@cakeiteasy/web-utils';

export * from './same-day-deadline-message.helper';

export const getPickupAvailability = (productType: IProductType | IProductTypeOverview): boolean => {
  const { pickupAvailable, outletsCount, bakery: { isPickupAvailable: bakeryPickupAvailable } } = productType;

  return outletsCount > 0 && pickupAvailable && bakeryPickupAvailable;
};

export const getDeliveryAvailability = (productType: IProductType | IProductTypeOverview): boolean => {
  const { deliveryAvailable, bakery: { isDeliveryAvailable } } = productType;

  return deliveryAvailable && isDeliveryAvailable;
};

export const getThirdPartyAvailability = (productType: IProductType | IProductTypeOverview): boolean => {
  const {
    bakery: {
      thirdPartyDeliveryEnabled,
      thirdPartyDeliveryAllowedOnWebshop,
      thirdPartyDeliveryAllowedOnMarketplace,
    }
  } = productType;

  return thirdPartyDeliveryEnabled && (thirdPartyDeliveryAllowedOnWebshop || thirdPartyDeliveryAllowedOnMarketplace);
};

export const getCustomNoteLabel = (
  product: IProductType | IProductTypeOverview,
  context: CUSTOM_NOTE_CONTEXT,
): CustomNoteLabel | null => {
  const isMarketplace = context === CUSTOM_NOTE_CONTEXT.MARKETPLACE;

  const text = isMarketplace ? product.marketplaceCustomNote : product.customNote;
  if (!text) {
    return null;
  }

  if (isMarketplace) {
    return {
      text,
      useCustomColor: product.marketplaceUseCustomNoteColor,
      bgColor: product.marketplaceCustomNoteColor,
      textColor: product.marketplaceCustomNoteTextColor,
      colorType: product.marketplaceColorTypeOfCustomNote,
    };
  }

  return {
    text,
    useCustomColor: product.useCustomNoteColor,
    bgColor: product.customNoteColor,
    textColor: product.customNoteTextColor,
    colorType: product.colorTypeOfCustomNote,
  };
};
